import {
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, REQUEST as NG_REQUEST, inject } from '@angular/core';
import { PlatformService } from '@shared/services/platform-service.service';
import { REQUEST } from '@shared/tokens/server.token';

@Injectable()
export class CookieInterceptor implements HttpInterceptor {
  requestHeader: HttpHeaders;
  platformService = inject(PlatformService);
  // REQUEST is only provided by the Express layer (server.ts). Under `ng serve`
  // the dev server renders without it, so treat it as absent rather than failing DI.
  req = this.platformService.run({
    server: () => inject(REQUEST, { optional: true }),
    browser: (): null => null,
  });
  // `ng serve` does provide Angular's own REQUEST (a web Request): without it dev SSR
  // renders anonymously and auth-guarded deep links redirect to /home.
  ngReq = this.platformService.run({
    server: () => inject(NG_REQUEST, { optional: true }),
    browser: (): null => null,
  });

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    // return next.handle(request);

    const req = this.platformService.run({
      server: () => {
        const cookieHeader = this.req?.headers?.cookie ?? this.ngReq?.headers.get('cookie');
        if (!cookieHeader) {
          return request;
        }

        const authReq = request.clone({
          setHeaders: {
            Cookie: cookieHeader,
          },
        });
        return authReq;
      },
      browser: () => request,
    });

    return next.handle(req);
  }
}
